import React from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Outlet, Navigate } from 'react-router-dom';

const USE_MOCK = process.env.REACT_APP_USE_MOCK === 'true';

function RequireAuth() {
  const { authState } = useOktaAuth();

  if (USE_MOCK) {
    return <Outlet />;
  }

  if (!authState) {
    return <div className="loading">Loading...</div>;
  }

  if (!authState.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}

export default RequireAuth;
